// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-1hWnt";
var _3 = "carry_on-ejEuO";
var _4 = "wrapper-Egrkj";
var _5 = "value-1r3pi";
var _6 = "measurement-BwJv_";
export { _1 as "__esModule", _2 as "root", _3 as "carry_on", _4 as "wrapper", _5 as "value", _6 as "measurement" }
export default { "__esModule": _1, "root": _2, "carry_on": _3, "wrapper": _4, "value": _5, "measurement": _6 }
